import { $GateMapMarkerTip } from '@stores/editingMarkerStores';
import { useStore } from 'effector-react';

export function EditingTipWidget() {
  const tips = useStore($GateMapMarkerTip.state) ?? [];
  if (!tips.length) return null;
  return (
    <div className="absolute top-20 p-10 select-none text-center rounded bg-orange text-white">
      {tips.map((tip, i) => (
        <p key={i}>{tip}</p>
      ))}
    </div>
  );
}
